// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1___ae2e723a00ec1881ade","cls2":"SimplePaperPodcast-cls2___c46bc53b2cd0c0e57a7 SimplePaperPodcast-cls1___ae2e723a00ec1881ade"};